import { render, staticRenderFns } from "./RewardList.vue?vue&type=template&id=072e0a47&scoped=true&"
import script from "./RewardList.vue?vue&type=script&lang=js&"
export * from "./RewardList.vue?vue&type=script&lang=js&"
import style0 from "./RewardList.vue?vue&type=style&index=0&id=072e0a47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e0a47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072e0a47')) {
      api.createRecord('072e0a47', component.options)
    } else {
      api.reload('072e0a47', component.options)
    }
    module.hot.accept("./RewardList.vue?vue&type=template&id=072e0a47&scoped=true&", function () {
      api.rerender('072e0a47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/RewardList.vue"
export default component.exports